import moment from 'moment';
import React, { Component } from 'react';
import { connect } from "react-redux";
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import '../../stylesheet/dashboard.css';
import '../../stylesheet/profilecard.css';
import CardDesign from '../carddesign/carddesign.jsx';
import LeftLink from '../leftlink/leftlink.jsx';
import AuthNavbar from '../navigation/authnavigation.jsx';
import { Link, NavLink, withRouter } from 'react-router-dom';
import logo from "../../images/SIMSLogo.png";
import CardInfo from './cardlist'
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import Loader from '../loader/loader.jsx';
import { toast, ToastContainer } from 'react-toastify';
import RaisedButton from 'material-ui/RaisedButton';
import SuccessPopup from '../secretqbutton/secretqbutton.jsx';
// import noCards from '../../images/noImage.jpg'


const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    cardState: state.getCardReducer.cardState,
    display: state.getCardReducer.display,
    profileState: state.getProfileReducer.profileState,
    optionState: state.selectedTabReducer.selectedTabReducer,
})
const mapDispatchToProps = dispatch =>
({
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
    fetchCard(state) {
        dispatch(
            actions.getCardAction(state)
        )
    },
    fetchSelectedTab(selectedOption) {
        dispatch(
            actions.selectedtabAction(selectedOption)
        )
    },
    clearInput() {
        dispatch(
            actions.clearInputAction()
        )
    },
    clearProfile() {
        dispatch(
            actions.clearProfileAction()
        )
    },
    fetchProfileState(history) {
        dispatch(
            actions.getProfileAction(history)
        )
    },
    fetchCardImage(programId) {
        dispatch(
            actions.getCardImageAction(programId)
        )
    },

})

const JSEncrypt = window.JSEncrypt
class DashBoard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedCard: [],
            initialvalue: '',
            loader: true,
            useClass: "",
            cardSelected: false,
            cardDetailsId: 1,
            cardState: [],
            lastSuccessfulLogin: localStorage.getItem('lastSuccessfulLogin'),
            lastUnsuccessfulLogin: localStorage.getItem('lastUnsuccessfulLogin')
            // cardState: []
        }
        this.handleCardClick = this.handleCardClick.bind(this)
    }

    handleCardClick(state) {
        this.setState({
            selectedCard: state,
            cardState: state,
            cardSelected: true,
        }, () => {

            this.setState({
                useClass: "tile"
            })

            // if (status === "Not Activated") {
            //     this.setState({
            //         useClass: "natile"
            //     })
            // } else if (status === "Activated") {
            //     this.setState({
            //         useClass: "tile"
            //     })
            // } else {
            //     this.setState({
            //         useClass: "cltile"
            //     })
            // }
            document.getElementById("tilediv").style.display = "block"

        })
    }


    getMyMonth(cmonth) {
        if (cmonth === 0) {
            return cmonth = "January"
        } else if (cmonth === 1) {
            return cmonth = "February"
        } else if (cmonth === 2) {
            return cmonth = "March"
        } else if (cmonth === 3) {
            return cmonth = "April"
        } else if (cmonth === 4) {
            return cmonth = "May"
        } else if (cmonth === 5) {
            return cmonth = "June"
        } else if (cmonth === 6) {
            return cmonth = "July"
        } else if (cmonth === 7) {
            return cmonth = "August"
        } else if (cmonth === 8) {
            return cmonth = "September"
        } else if (cmonth === 9) {
            return cmonth = "October"
        } else if (cmonth === 10) {
            return cmonth = "November"
        } else if (cmonth === 11) {
            return cmonth = "December"
        }
    }
    componentWillMount() {
        this.props.fetchPublicKey(false);
        localStorage.setItem("comp", "othercomp")
        localStorage.setItem('taboption', 'tab1')

    }
    // componentWillReceiveProps(nextpProps){

    //     if(nextpProps.cardState.status !== 200){
    //         this.setState({
    //             loader:true
    //         })
    //     }
    //     else{
    //         this.setState({
    //             loader:false
    //         })
    //     }
    // }

    componentDidMount() {
        localStorage.setItem("landing", false)
        this.setState({
            initialvalue: "initial",
        })

        this.props.fetchSelectedTab(localStorage.getItem('taboption'))
        this.props.fetchProfileState(this.props.history)
        //document.getElementById("tilediv").style.display = "none"

        const { publicKey } = this.props
        let _this = this
        setTimeout(function () {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);

                const state = {
                    applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }
                _this.props.fetchCard(state)
            }
        }, 500);



        setTimeout(function () {
            let ele = document.getElementById("firstDiv")
            ele.classList.remove("layoutopac")

        }, 2000)

    }
    refreshpage = () => {
        document.getElementById("myModal").style.display = "none"
        localStorage.removeItem("kycStatus");
    }
    componentDidUpdate = () => {



    }






    formatAMPM(date) {
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    }
    getLocalTime = (key) => {

        let local = localStorage.getItem(key)


        let spiltArray = local.split(" ");
        let indDate = spiltArray[0].split("/")

        let utcDateString = indDate[2] + "/" + indDate[1] + "/" + indDate[0] + " " + spiltArray[1]

        let utcobj = new Date(utcDateString)
        let utctimestamp = utcobj.getTime()

        let d = new Date()
        let localOffset = d.getTimezoneOffset() * 60000;


        // let utc = localTime + localOffset;

        let localTime = utctimestamp - localOffset

        let utcdate = new Date(localTime);

        let localTimeToDisplay = utcdate.toLocaleString().split(",")

        return localTimeToDisplay[0] + " " + this.formatAMPM(utcdate)

    }
    getUnLocalTime = (key1) => {

        let local = localStorage.getItem(key1)


        let spiltArray = local.split(" ");
        let indDate = spiltArray[0].split("/")

        let utcDateString = indDate[2] + "/" + indDate[1] + "/" + indDate[0] + " " + spiltArray[1]

        let utcobj = new Date(utcDateString)
        let utctimestamp = utcobj.getTime()

        let d = new Date()
        let localOffset = d.getTimezoneOffset() * 60000;


        // let utc = localTime + localOffset;

        let localTime = utctimestamp - localOffset

        let utcdate = new Date(localTime);

        let localTimeToDisplay = utcdate.toLocaleString().split(",")

        return localTimeToDisplay[0] + " " + this.formatAMPM(utcdate)

    }
    handleLogout(e) {
        localStorage.clear();
        this.props.clearInput()
        this.props.clearProfile()
        this.props.history.push("/logout")

    }
    handleSelect1 = (event, index, value) => {

        const { cardState } = this.props
        for (let i = 0; i < cardState.body.length; i++) {


            if (cardState.body[i].cardDetailsId === value) {
                this.setState({
                    cardInUse: cardState.body[i],
                    selectedCard: [cardState.body[i]],
                    selectedNewCard: cardState.body[i],
                    cardSelected: true,
                    balance: cardState.body[i].expDate.slice(0, 2) + '/' + cardState.body[i].expDate.slice(2),
                    initialvalue: "changed",
                    cardDetailsId: value,
                    nameonCard: cardState.body[i].firstName + " " + cardState.body[i].lastName
                })
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        let _this = this

        this.setState({
            loader: true
        })
        try {
            if (_this.state.initialvalue === 'initial') {

                if (nextProps.cardState && nextProps.cardState.length !== 0) {
                    this.setState({
                        loader: false,
                        selectedCard: [nextProps.cardState.body[0]],
                        nameonCard: nextProps.cardState.body[0].firstName + " " + nextProps.cardState.body[0].lastName,
                        selectedNewCard: nextProps.cardState.body[0],
                        balance: nextProps.cardState.body[0].expDate && nextProps.cardState.body[0].expDate.slice(0, 2) + '/' + nextProps.cardState.body[0].expDate.slice(2),
                        cardDetailsId: nextProps.cardState.body[0].cardDetailsId
                    })
                }
            }
            else {

                this.setState({
                    loader: false
                })
                // if (nextProps.cardState && nextProps.cardState.length !== 0) {
                //     for (let i = 0; i < nextProps.cardState.body.length; i++) {
                //         if (nextProps.cardState.body[i].cardDetailsId === _this.state.value) {
                //             
                //             this.setState({                              
                //                 loader: false,
                //                 selectedCard: nextProps.cardState.body[i]
                //             })
                //         }
                //     }
                // }
            }
        } catch (e) {

        }
    }

    donotUpgradeNow =()=>{
        localStorage.setItem('showIncrease', false )
        setTimeout(function () {
            this.props.history.push("/home")
        }.bind(this), 1500);
    }

    UpgradeNow =()=>{
        localStorage.setItem('showIncrease', false )
        setTimeout(function () {
            this.props.history.push("/increase-mycard-limit")
        }.bind(this), 1500);
    }

    render() {
        localStorage.setItem("landing", false)
        const { selectedCard, useClass, lastSuccessfulLogin, lastUnsuccessfulLogin, cardDetailsId, balance } = this.state
        const { cardState, profileState, } = this.props
       
        console.log("Selected cards",selectedCard && selectedCard[0])
        if(selectedCard && selectedCard.length > 0 ){
            localStorage.setItem('mnuMW' , selectedCard[0].provisionToDigitalWallet)
        }

        // localStorage.setItem("mailingId", profileState.body.mailingInformation.mailingId || null)
        return (
            <div style={{}} id="firstDiv" className="layoutopac">

                <div className="" >
                    <div className="row">
                        <AuthNavbar />
                    </div>
                </div>

                <div className="container" >
                    <div className="row">


                        {profileState.status === 200 ?
                            <div className="col-sm-12" style={{ padding: "0px 25px" }}>
                                <div className="row">
                                    {/* <div className="col-md-12">
                                        <div className="greeting-message">
                                            <div className="row">
                                                <div className="col-md-8">
                                                    <div className="header">
                                                        <h3>Hello {profileState.body.firstName}</h3>
                                                        <span>Today is {moment().format('LLLL')}</span>

                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div> */}

                                    {/* <div className="col-sm-12 " >
                                        <div className="dashboard-well box-shadow-style">
                                            <div className="row" >
                                                <div className="col-md-5 login-success" >
                                                    <label>Last Successful Login  </label>
                                                    {lastSuccessfulLogin !== null && lastSuccessfulLogin !== "null" && lastSuccessfulLogin !== "" &&
                                                        <span> {this.getLocalTime("lastSuccessfulLogin")} </span>}
                                                </div>

                                                <div className="col-md-5 login-fail nopadding" >
                                                    <label>Last Unsuccessful Login  </label>
                                                    {lastUnsuccessfulLogin !== null && lastUnsuccessfulLogin !== "null" && lastUnsuccessfulLogin !== "" &&

                                                        <span> {this.getLocalTime("lastUnsuccessfulLogin")} </span>}
                                                </div>
                                            </div>
                                        </div>
                                </div> */}
                                </div>
                            </div>
                            :
                            <div></div>}


                        <div className="col-sm-12" style={{ padding: "0px 40px" }}>
                            <div className="row">
                                <div className="col-sm-12 summary ">
                                    <div className="row " >
                                        <div className="col-sm-12 " >

                                            <div className="dashboard-well">
                                                <div className="card-summary-header">
                                                    <h4 className='logmainheading mainheading'>My Card Summary</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12" >
                                            <div className="row " >
                                                <div className='col-sm-6 m-0 p-0'>
                                                    {/* {selectedCard && selectedCard.length > 0 &&
                                                        <div className="col-md-12 col-sm-12 col-lg-12 col-xl-12 mr-0" style={{ cursor: "pointer", marginTop: "10px" }} >
                                                            <CardDesign name={selectedCard && selectedCard.firstName + " " + selectedCard && selectedCard.lastName} cardno={selectedCard && selectedCard.cardNumber} balance={selectedCard && selectedCard.expDate.slice(0, 2) + '/' + selectedCard && selectedCard.expDate.slice(2)} cardImage={selectedCard && selectedCard.cardProgramId} startwith="4123" />
                                                        </div>
                                                    } */}

                                                    {cardState && cardState.status && cardState.status === 200 && selectedCard && selectedCard.length > 0 ?
                                                        <div className="col-md-12 col-sm-12 col-lg-12 col-xl-12 ml-1 pb-4 p-0 m-0" style={{ cursor: "pointer", marginTop: "10px" }}>
                                                            {/* <CardDesign name={cardState.body[i].firstName + " " + cardState.body[i].lastName} cardno={cardState.body[i].cardNumber} balance={cardState.body[i].expDate.slice(0, 2) + '/' + cardState.body[i].expDate.slice(2)} cardImage={cardState.body[i].cardProgramId} startwith="4123" /> */}
                                                            <CardDesign 
                                                            name={this.state.nameonCard} 
                                                            cardno={selectedCard && selectedCard[0].cardNumber} 
                                                            balance={balance} 
                                                            cardImage={(selectedCard && selectedCard[0].cardProgramId)} 
                                                            kitNo={(selectedCard && selectedCard[0].kitNo)}   
                                                            provisionDigitalWallet={(selectedCard[0].provisionToDigitalWallet)} 
                                                            cardStatus={(selectedCard[0].cardStatus)} 
                                                            startwith="4123"  />

                                                        </div>
                                                        :
                                                        <Loader />
                                                    }
                                                </div>
                                                {cardState && cardState.status && cardState.status === 200 && selectedCard && selectedCard.length > 0 &&
                                                    selectedCard[0].provisionToDigitalWallet === true &&
                                                    <div className='col-md-6 col-sm-12'>
                                                        <div className="row">
                                                        <div className="" style={{border : '1px solid rgb(102, 102, 102)' , padding: '20px' , borderRadius : '16px'}}>
                                                            <h3 className='mainheading'>Great News!</h3>
                                                            <p>Your Card is ready to be added to your Apple or Google Wallet.</p>
                                                            <p> Select your preferred wallet below and follow the steps to get started. </p>
                                                            <Link to="/applewallet" className="btn" style={{ marginTop: "10px" , borderRadius : '8px' ,color :"white", backgroundColor : '#f69b2e' }}>
                                                                Apple Wallet
                                                            </Link>   
                                                            <Link to="/googlewallet" className="btn  ml-4" style={{ marginTop: "10px" , borderRadius : '8px' ,color :"white", backgroundColor : '#f69b2e' }}>
                                                            Google Wallet
                                                            </Link> 
                                                            </div>                                                       
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-md-12 col-sm-12 ">
                                            <div className="row">
                                               
                                                <div className='col-md-6 col-sm-12 mt-2'>
                                                    <div className="row">
                                                        <div className="col-md-4 col-sm-12 ml-1" style={{ padding: "13px 13px", fontSize: "16px", fontWeight: "bold", color: "#585555", }}>
                                                            <p>Card Number</p>
                                                        </div>
                                                        <div className="col-md-6 col-sm-12">
                                                            <SelectField
                                                                floatingLabelText=""
                                                                onChange={this.handleSelect1}
                                                                className="input-width simsfont"
                                                                name="Selected Card"
                                                                autoComplete='none'
                                                                value={cardDetailsId}>
                                                                {cardState && cardState.body && cardState.body.map((value, i) =>
                                                                    <MenuItem className='menuitem' value={cardState.body[i].cardDetailsId} primaryText={cardState.body[i].cardNumber} key={i} />
                                                                )}
                                                            </SelectField>
                                                        </div>
                                                    </div>
                                                </div>

                                                <CardInfo
                                                    selectedNewCard={this.state.selectedCard}
                                                    cardSelected={this.state.cardSelected} />

                                            </div>
                                        </div>

 


                                        {/* <div className="row">
                                                                <div className="col-md-5  tilepadding">
                                                                    <label className="tilecontent">Last Credit Posted </label>
                                                                </div>
                                                                <div className="col-md-6 text-left tilepadding">
                                                                    <span className="tileheadername"> : {cardState.body[0].lastCreditPosted || "NA"} </span><br />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-5  tilepadding">
                                                                    <label className="tilecontent">Last Debit Posted </label>
                                                                </div>
                                                                <div className="col-md-6 text-left tilepadding">
                                                                    <span className="tileheadername"> : {cardState.body[0].lastDebitPosted || "NA"}  </span><br />
                                                                </div>
                                                                </div>*/}

                                        {/* <div className="col-md-7 col-sm-12">
                                                        <div className="row">
                                                            <div className="col-md-5 tilepadding">
                                                                <label className="tilecontent">Ledger Balance </label>
                                                            </div>
                                                            <div className="col-md-7 text-left tilepadding">
                                                                <span className="tileheadername">{cardState.body[0].ledgerBalance || "NA"}  </span><br />
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-5 tilepadding">
                                                                <label className="tilecontent">Last Credit Posted </label>
                                                            </div>
                                                            <div className="col-md-6 text-left tilepadding">
                                                                <span className="tileheadername">{cardState.body[0].lastCreditPosted || "NA"} </span><br />
                                                            </div>
                                                        </div> */}
                                        {/* <div className="row">
                                                                <div className="col-md-5  tilepadding">
                                                                    <label className="tilecontent">Last Statement Closing Balance </label>
                                                                </div>
                                                                <div className="col-md-7 text-left tilepadding">
                                                                    <span className="tileheadername"> : {selectedCard.lastStatementClosingBalance || "NA"}  </span><br />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-5  tilepadding">
                                                                    <label className="tilecontent">Current Statement Balance </label>
                                                                </div>
                                                                <div className="col-md-7 text-left tilepadding">
                                                                    <span className="tileheadername"> : {selectedCard.currentStatementBalance || "NA"}  </span><br />
                                                                </div>
                                                            </div> */}

                                        {/* </div> */}
                                    </div>
                                </div>
                                    
                            </div>
                        </div>
                    </div>
                   {/* // kycIntegration === true && */}
                {/* { localStorage.getItem('showIncrease') === 'true' && localStorage.getItem('shlimit') === '0' &&
                    <div className='upgradeCardNotification' >
                    <div className='cardwrapper'>
                        <div className="col-md-12 p-4"> 
                            <h5>Would you like to upgrade your card now to increase your card limits?</h5>
                        </div>
                        <div className="col-md-12"> 
                            <div className="row">
                                <div className="col-md-3"></div>
                                <div className="col-md-9 d-flex flex-row ">
                                            <div className='mr-2'>
                                            <div className="tooltip" style={{ position:"relative" , top: "0px", left:'1px', textAlign: "left" }}>

                                                <RaisedButton
                                                    label="No"
                                                    disabled={this.state.disabled}
                                                    onClick={this.donotUpgradeNow}
                                                    className=" "
                                                    backgroundColor="#333"
                                                    labelColor="#fff"
                                                    style={{ minWidth: "100px", marginTop: "20px", borderRadius: "6px" }}
                                                >

                                                            <span className="tooltiptext  text-left" style={{ fontSize: "14px", width: "350px", top: "25px", top: "-92px" }} >
                                                                <label className='ml-3'> <label style={{ color: "green" }}></label> You can always increase your card limits later by clicking on the link under Additional Services</label>
                                                            </span>

                                                </RaisedButton>
                                                
                                                </div>


                                            </div>
                                                <RaisedButton
                                                    label="Yes"
                                                    disabled={this.state.disabled}
                                                    onClick={this.UpgradeNow}
                                                    className=" "
                                                    backgroundColor="#FAA61A"
                                                    labelColor="#000"
                                                    style={{ minWidth: "100px", marginTop: "20px", borderRadius: "6px" , marginLeft: '130px' }}
                                                />
                                            
                                </div>
                                <div className="col-md-12 mt-3">
                                    <span className='textRed'><strong>Note :</strong> If you prefer 'NO', You can always increase your card limits later by clicking on the link under Additional Services.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                } */}

                </div>

            </div>

        );
    }
}

DashBoard.defaultProps = {
    cardState: {
        status: 400
    },
    profileState: {
        status: 400
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DashBoard));


// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard.jsx